import { render } from "./SoleTrader.vue?vue&type=template&id=51e5d880&scoped=true"
import script from "./SoleTrader.vue?vue&type=script&lang=js"
export * from "./SoleTrader.vue?vue&type=script&lang=js"

import "./SoleTrader.vue?vue&type=style&index=0&id=51e5d880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e5d880"]])

export default __exports__